import React from "react";
import { PaymentDataModeFirstContainer } from "app/pages/Booking/Payment/PaymentData/PaymentDataModeFirst/PaymentDataModeFirstContainer";

export default props => <PaymentDataModeFirstContainer {...props} />;
